<div class="modal-header">
  <span class="pull-right">
      <button class="btn btn-default btn-xs" (click)="close()"><i class="glyphicon glyphicon-remove"></i></button>
    </span>
<span>
  <h4 class="modal-title">{{ request.title }}</h4>
</span>

</div>
<div class="modal-body" [formGroup]="planningForm">
  <div class="form-horizontal">

    <div class="form-group" [class.has-error]="plannedPlantingDate.invalid">
      <label class="control-label col-sm-3">Planned Plant Date</label>
      <app-ce-date-picker formControlName="plannedPlantingDate"
                          [minDate]="minPlantDate"
                          placement="right">
      </app-ce-date-picker>
    </div>
    <div class="alert alert-danger col-sm-offset-3" *ngIf="!plannedPlantingDate.pristine && plannedPlantingDate.errors?.min">
      Planned Plant Date must be today or later
    </div>
    <div class="alert alert-danger col-sm-offset-3" *ngIf="!plannedPlantingDate.pristine && plannedPlantingDate.errors?.dayOfWeek">
      Valid days of week: {{ request.recurrenceDays | recurrenceDayNames }}
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3">Tags ONLY!</label>
      <span class="col-sm-9">
        <ui-switch formControlName="tagsOnly" checkedLabel="Yes" uncheckedLabel="No"></ui-switch>
      </span>
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3">Compliance Status</label>
      <div class="col-sm-9">
        <table class="table table-bordered">
          <tr class="active">
            <th>Regulatory Status</th>
            <th>PPQ Required?</th>
            <th>Phyto Inspection Required?</th>
          </tr>
          <tr>
            <td>{{request.regulatoryStatus }}</td>
            <td>{{request.ppqRequired  | yesNo }}</td>
            <td>{{request.phytoInspectionRequired  | yesNo }}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="form-group">
        <label class="control-label col-sm-3">Beneficial Insects Allowed?</label>
        <span class="col-sm-9">
          <ui-switch formControlName="insectsAllowed" checkedLabel="Yes" uncheckedLabel="No"></ui-switch>
        </span>
      </div>

    <div class="form-group row">
      <label class="control-label col-sm-3">Pesticides Allowed</label>
      <div class="col-sm-9">
        <span class="form-control-static pesticide-value">{{ request.pesticideInstruction }}</span>
        <div *ngIf="request.pesticideLifeOfPlant || request.pesticidesAllowedAfterDays > 0">
          <ng-container *ngIf="request.pesticideLifeOfPlant === true">
            Life of plant
          </ng-container>
          <ng-container *ngIf="request.pesticideLifeOfPlant === false">
            Resume standard pesticide application
            <strong>{{ request.pesticidesAllowedAfterDays }}</strong>
            days after planting
          </ng-container>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3">Desired Plant Date</label>
      <span class="col-sm-9 form-control-static">
        {{request.requestedPlantingDate | date: 'MM/dd/yyyy'}}
      </span>
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3">Advancement Preferences</label>
      <div class="col-sm-9">
        <table class="table table-bordered">
          <tr class="active">
            <th>For Advancement?</th>
            <th>Haploid Induction?</th>
            <th>Many-to-One?</th>
            <th>Unique Pedigree?</th>
          </tr>
          <tr>
            <td>{{request.standardHarvest | yesNo }}</td>
            <td>{{request.haploidInduction  | yesNo }}</td>
            <td>{{request.manyToOne  | yesNo }}</td>
            <td>{{request.uniquePedigree  | yesNo }}</td>
          </tr>
        </table>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3">Harvested Seed Available in Packet </label>
      <span class="col-sm-9 form-control-static">
        {{request.requestedSeedPacketDate | date: 'MM/dd/yyyy'}}
      </span>
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3">Replicates</label>
      <span class="col-sm-9 form-control-static">
        {{request.numberOfReps}}
      </span>
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3">Indexing?</label>
      <span class="col-sm-9 form-control-static">
        {{request.indexing | yesNo}}
      </span>
    </div>

    <div class="form-group">
      <label class="control-label col-sm-3">Embryo Rescue?</label>
      <span class="col-sm-9 form-control-static">
        {{request.embryoRescue | yesNo}}
      </span>
    </div>

    <div class="form-group" *ngIf="isWheatRequest">
      <label class="control-label col-sm-3">Seeds Per Cell</label>
      <span class="col-sm-9 form-control-static">
        {{request.numberOfSeedsPerCell}}
      </span>
    </div>

    <accordion>
      <accordion-group heading="Treatments" [isOpen]="true">
        <app-vertical-tab-group>
          <app-vertical-tab
                            *ngFor="let treatment of treatments.controls; let i = index"
                            [title]="'Treatment ' + existingTreatmentData[i].treatmentNumber"
                            [hasError]="treatment.invalid">
            <app-request-planning-treatment
                                            [existingTreatmentFormData]="existingTreatmentData[i]"
                                            [treatmentFormGroup]="treatment"
                                            #treatmentForm>
            </app-request-planning-treatment>
            <div class="text-right">
              <button class="btn btn-default" type="button" (click)="applyAll(treatmentForm)">
                Apply to All
              </button>
            </div>
            <app-request-planning-treatment-spray [existingTreatmentFormData]="existingTreatmentData[i]"
                                                  [treatmentFormGroup]="treatments.at(i)"
                                                  [planningForm]="planningForm"
                                                  [plannedPlantingDate]="plannedPlantingDate.value">
            </app-request-planning-treatment-spray>
            <div class="text-right" *ngIf="existingTreatmentData[0].sprayBoothStudyInstructions?.length > 0">
              <button class="btn btn-default" type="button" (click)="applyAllSpray(treatmentForm)">
                Apply to All
              </button>
            </div>
          </app-vertical-tab>
        </app-vertical-tab-group>
      </accordion-group>
    </accordion>

    <table *ngIf="requestedSamplings && requestedSamplings.length" class="table table-bordered">
      <thead>
        <tr class="active">
          <th>Laboratory</th>
          <th>Assay Type</th>
          <th>Tissue Type</th>
          <th>Tissue Collection</th>
          <th *ngIf="displayGrowthStage">Growth Stage</th>
          <th *ngIf="displayDaysAfterPlanting">Days after Planting</th>
          <th>Notes</th>
        </tr>
      </thead>
      <tbody formArrayName="requestedSamplingNotes">
        <tr *ngFor="let requestedSamplingNote of requestedSamplingNotes.controls; let i = index" [class.has-error]="requestedSamplingNote.invalid">
          <td>{{ requestedSamplings[i].laboratory }}</td>
          <td>{{ requestedSamplings[i].assay }}</td>
          <td>{{ requestedSamplings[i].tissueType }}</td>
          <td>{{ requestedSamplings[i].tissueCollectionType }}</td>
          <td *ngIf="displayGrowthStage">{{ requestedSamplings[i].growthStage }}</td>
          <td *ngIf="displayDaysAfterPlanting">{{ requestedSamplings[i].daysAfterPlanting }}</td>
          <td><textarea
                   [formControlName]="i"
                   maxlength="1000"
                   class="form-control"
                   rows="2"></textarea>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="form-group" [class.has-error]="plannedAoiLocation.invalid">
      <label class="control-label col-sm-3">Specific AOI required?</label>
      <span class="col-sm-2">
        <ui-switch formControlName="specificAoiRequired" checkedLabel="Yes" uncheckedLabel="No" [disabled]="request.phytoInspectionRequired"></ui-switch>
      </span>
      <span *ngIf="specificAoiRequired.value === true" class="col-sm-7">
        <textarea formControlName="plannedAoiLocation" class="form-control" placeholder="Enter AOI" maxlength="500" rows="1"></textarea>
      </span>
    </div>

    <div class="form-group" [class.has-error]="notes.invalid">
      <label class="control-label col-sm-3">Notes</label>
      <div class="col-sm-9">
        <textarea class="form-control" formControlName="notes" maxlength="10000" rows="3"></textarea>
      </div>
    </div>

    <div class="form-group" [class.has-error]="requestType.invalid">
      <label class="control-label col-sm-3">Request Type</label>
      <span class="col-sm-4">
        <select formControlName="requestType" class="form-control">
          <option [ngValue]="null"></option>
          <option *ngFor="let option of requestTypes" [ngValue]="option.id">{{ option.name }}</option>
        </select>
      </span>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-default" (click)="saveState()">Save</button>
  <button class="btn btn-primary" (click)="completeRequestPlan()" [disabled]="planningForm.invalid">Complete Request Plan</button>
</div>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/request-planning-modal/request-planning-modal.component.html